<template>
  <Modal
    v-model="uploadImageModal"
    title="图片裁剪上传"
    @on-ok="ok"
    @on-cancel="cancel"
  >
    <!--https://www.jianshu.com/p/6a77430023f1-->
    <div class="cropperHeader">
      <label class="controlLabel">本地上传</label>
      <Upload ref="upload" id="dmCropperuploads" :show-upload-list="false" :format="['jpg','jpeg','png']" :max-size="2048" :before-upload="handleBeforeUpload" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" type="drag"  action="a" style="display: inline-block">
        <label for="dmCropperuploads" class="ivu-btn">选取文件</label>
      </Upload>
    </div>
    <div class="cropperBody">
      <vueCropper
        ref="avatarCropper"
        :img="avatarCropper.img"
        :outputSize="avatarCropper.size"
        :outputType="avatarCropper.outputType"
        :info="avatarCropper.info"
        :canScale="avatarCropper.canScale"
        :autoCrop="avatarCropper.autoCrop"
        :autoCropWidth="avatarCropper.autoCropWidth"
        :autoCropHeight="avatarCropper.autoCropHeight"
        :fixed="avatarCropper.fixed"
        :fixedNumber="avatarCropper.fixedNumber"
      ></vueCropper>
    </div>
  </Modal>
</template>

<script>
import VueCropper from 'vue-cropper'
export default {
  components: {
    VueCropper
  },
  data () {
    return {
      uploadImageModal:false,
      avatarCropper: {
        img: '',
        info: true,
        size: 1,
        outputType: 'jpeg',
        canScale: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 300,
        autoCropHeight: 250,
        // 开启宽度和高度比例
        fixed: true,
        fixedNumber: [4, 4]
      }
    }
  },
  methods: {
    openModal () {
      this.uploadImageModal = true
    },
    ok () {
      // 获取cropper的截图的base64 数据
      this.$refs.avatarCropper.getCropData(data => {
        this.$emit("avatarPicBase64",data);
        this.avatarCropper.img ="";
      })
    },
    cancel () {

    },

    handleModifyAvatar(){
      this.$refs.uploadAvatar.openModal();
    },
    handleBeforeUpload(file) {
      // 创建一个 FileReader 对象
      let reader = new FileReader()
      // readAsDataURL 方法用于读取指定 Blob 或 File 的内容
      // 当读操作完成，readyState 变为 DONE，loadend 被触发，此时 result 属性包含数据：URL（以 base64 编码的字符串表示文件的数据）
      // 读取文件作为 URL 可访问地址
      reader.readAsDataURL(file)
      const _this = this
      reader.onloadend = function (e) {
        _this.avatarCropper.img = reader.result;
        file.url = reader.result
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '文件 ' + file.name + ' 格式不正确，请上传 jpg 或 png 格式的图片。'
      })
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '超出文件大小限制',
        desc: '文件 ' + file.name + ' 太大，不能超过 2M。'
      })
    }
  }
}
</script>

<style scoped>
  .controlLabel{
    float: left;
    min-width: 50px;
    width:100px;
    margin-right: 10px
  }
  #dmCropperuploads{
    float: left;
  }
  .cropperHeader{
    margin-bottom:15px;
  }
  .cropperHeader:after{display:block;clear:both;content:"";visibility:hidden;height:0}
  .cropperBody{
    height: 300px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background-color: #ebebeb;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/view/components/uploadAvatar/uploadAvatar.vue